import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { DEFAULT_GET_LIMIT } from '../shared/constants/operationals';

export const CLUSTERS_API_NAME: string = 'clusters';
export const CLUSTERS_API_ENDPOINT: string = environment.API_BASE_PATH;

@Injectable({
  providedIn: 'root',
})
export class ClusterService {
  listClusters(list_params?: ListClusterParams): Observable<any> {
    const api_name: string = CLUSTERS_API_NAME;
    const path: string = '/cluster';
    const query_string_params: any = {
      cursor: list_params?.cursor || null,
      limit: list_params?.limit || DEFAULT_GET_LIMIT,
    };
    const init = { response: true, queryStringParameters: query_string_params };
    return from(API.get(api_name, path, init));
  }

  readCluster(cluster_id: string): Observable<any> {
    const api_name: string = CLUSTERS_API_NAME;
    const path: string = `/cluster/${cluster_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  listTanMaxByCluster(cluster_id: string): Observable<any> {
    const api_name: string = CLUSTERS_API_NAME;
    const path: string = `/tan-max/cluster/${cluster_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  createTanMax(tan_max: TanMaxCreateInput): Observable<any> {
    const api_name: string = CLUSTERS_API_NAME;
    const path: string = '/tan-max';
    const init = { response: true, body: tan_max };
    return from(API.post(api_name, path, init));
  }

  deleteTanMax(tan_max_id: string): Observable<any> {
    const api_name: string = CLUSTERS_API_NAME;
    const path: string = `/tan-max/${tan_max_id}`;
    const init = { response: true };
    return from(API.del(api_name, path, init));
  }

  createCluster(cluster: Cluster): Observable<any> {
    const api_name: string = CLUSTERS_API_NAME;
    const path: string = '/cluster';
    const init = { response: true, body: cluster };
    return from(API.post(api_name, path, init));
  }

  updateCluster(cluster_id: string, cluster: ClusterUpdateInput): Observable<any> {
    const api_name: string = CLUSTERS_API_NAME;
    const path: string = `/cluster/${cluster_id}`;
    const init = { response: true, body: cluster };
    return from(API.put(api_name, path, init));
  }

  updateUsuryThreshold(cluster_code: string, steps_number: number, max_tan: number): Observable<any> {
    const api_name: string = CLUSTERS_API_NAME;
    const path: string = `/cluster/${cluster_code}/step/${steps_number}`;
    const init = { response: true, body: { max_tan } };
    return from(API.put(api_name, path, init));
  }
}

export interface ClusterConfiguration {
  steps_number: number;
  min_amount: number;
  max_amount: number;
  goal_tan: number;
  min_tan: number;
  max_tan: number;
}

export interface Cluster {
  cluster_id?: string;
  cluster_code: string;
  name: string;
  valid_from: number;
  valid_to: number;
  configurations: ClusterConfiguration[];
  object?: string;
  created_at?: number;
  updated_at?: number;
}

export interface ClusterUpdateInput {
  valid_from: number;
  valid_to: number;
  configurations: ClusterConfiguration[];
}

export interface TanMaxConfiguration {
  steps_number: number;
  value: number;
}

export interface TanMax {
  tan_max_id: string;
  valid_from: number;
  cluster_id: string;
  cluster_code: string;
  configurations: TanMaxConfiguration[];
  created_at?: number;
  updated_at?: number;
}

export interface TanMaxCreateInput {
  valid_from: number;
  cluster_id: string;
  cluster_code: string;
  configurations: TanMaxConfiguration[];
}

export interface ListClusterParams {
  cursor?: string | null;
  limit?: number;
}
